<div class="d-flex gap-8 align-items-center text-black">

  <span class="rounded-circle font-20 p-2 text-white material-icons"
    [ngClass]="{'bg-success' : data.status.includes('success'), 'bg-danger': data.status.includes('error'),
              'bg-warning': data.status.includes('warning')}">
    {{ data.status.includes('success') ? 'download_done' : (data.status.includes('error') ? 'close' : 'warning') }}
    </span>

  <div>
    <h6 class="mb-0 font-trueno-bold font-14">
      {{ (data.status.includes('success') ? 'COMMON.SNACK_SUCCESS' : (data.status.includes('error') ? 'COMMON.SNACK_ERROR' : 'COMMON.SNACK_WARNING')) | translate }}
    </h6>
    <p class="font-14 fw-normal" *ngIf="data.value" [innerHTML]="data.value"></p>
  </div>
  <span class="material-icons-outlined ms-auto font-16 lightGray2 pointer" (click)="sbRef.dismiss()">close</span>
</div>
